import api from './api';
import { LoginResult } from '../model/LoginResult';
import { to } from '../util/util';

// Rolling sign-in: a click or key press renews the token (at most once an hour); an idle tab reloads
// when the token runs out, which lands on the login page.
const renewAfterMs = 60 * 60 * 1000;
const checkEveryMs = 60 * 1000;

let expiresAt = 0;
let renewedAt = 0;
let renewing = false;

// expiration and serverTime both come from the server, so the local clock being off doesn't matter
const setExpiry = (result: LoginResult) => {
    const remaining = new Date(result.expiration).getTime() - new Date(result.serverTime).getTime();
    expiresAt = Date.now() + remaining;
    renewedAt = Date.now();
};

const renew = async () => {
    if (renewing || Date.now() - renewedAt < renewAfterMs) return;
    renewing = true;
    const [ err, result ] = await to(api().refreshToken());
    renewing = false;
    if (result && !err) setExpiry(result);
};

const reloadWhenExpired = () => {
    if (Date.now() >= expiresAt) window.location.reload();
};

export const startSessionKeeper = (result: LoginResult) => {
    setExpiry(result);
    window.addEventListener('click', renew, { passive: true });
    window.addEventListener('keydown', renew, { passive: true });
    window.setInterval(reloadWhenExpired, checkEveryMs);
};
